import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const RING = ["ring-2", "ring-amber-400", "ring-offset-2", "bg-amber-50", "transition-shadow"];

export function useFocusRow(prefix, ready) {
  const [params, setParams] = useSearchParams();
  const focus = params.get("focus");
  useEffect(() => {
    if (!focus || !ready) return;
    let tries = 0;
    const tick = () => {
      const el = document.querySelector(`[data-testid="${prefix}-${focus}"]`);
      if (!el) { if (tries++ < 20) setTimeout(tick, 150); return; }
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      const targets = el.tagName === "TR" ? [...el.children] : [el];
      const cls = el.tagName === "TR" ? ["bg-amber-100", "transition-colors"] : RING;
      targets.forEach((t) => t.classList.add(...cls));
      setTimeout(() => targets.forEach((t) => t.classList.remove(...cls)), 5000);
      const p = new URLSearchParams(params); p.delete("focus"); setParams(p, { replace: true });
    };
    tick();
  }, [focus, ready, prefix]); // eslint-disable-line react-hooks/exhaustive-deps
  return focus;
}
